export enum ProjectStatusEnum {
  OPEN = 'OPEN',
  DONE = 'DONE',
}

export enum ProjectDrawerTabEnum {
  PROJECT = 'project',
  OPPORTUNITY = 'opportunity',
}
